import { render, staticRenderFns } from "./EventCategoryDetails.vue?vue&type=template&id=52bd9956&scoped=true&"
import script from "./EventCategoryDetails.vue?vue&type=script&lang=ts&"
export * from "./EventCategoryDetails.vue?vue&type=script&lang=ts&"
import style0 from "./EventCategoryDetails.vue?vue&type=style&index=0&id=52bd9956&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52bd9956",
  null
  
)

export default component.exports